import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { CustomerSelector } from './components/CustomerSelector'

export const CustomerValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <CustomerSelector
    multiple
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={Array.isArray(value) ? value : []}
    onChange={next => onChange({ value: next })}
    validationErrors={validationErrors}
  />
)
